/*
  NS V2 Neurabody App (sections/nb-ns-v2-neurabody-app.liquid)

  Feature cards are tabs: the active one is highlighted and its stage visual is
  shown. Tabs auto-advance every `data-autoplay` seconds (0 = off), pausing
  while the pointer or focus is inside the section and stopping for good once
  the visitor picks a tab. No autoplay with prefers-reduced-motion.

  `data-trigger="hover"` also switches tabs on mouse hover; click/tap and the
  keyboard always work, so touch devices are unaffected.
*/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-nb-ns-v2-na]';

  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function init(root) {
    if (root.nbNsV2NaInit === true) {
      return;
    }

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-na-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-na-panel]'));

    if (tabs.length === 0 || tabs.length !== panels.length) {
      return;
    }
    root.nbNsV2NaInit = true;

    var current = 0;
    var timer = null;
    var stopped = false;
    var hovering = false;
    var focused = false;
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) * 1000 || 0;
    var hoverTrigger = root.getAttribute('data-trigger') === 'hover';

    function activate(index, moveFocus) {
      current = (index + tabs.length) % tabs.length;

      tabs.forEach(function (tab, i) {
        var active = i === current;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var active = i === current;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      if (moveFocus === true) {
        tabs[current].focus();
      }
    }

    function stopTimer() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (stopped || hovering || focused || delay <= 0 || tabs.length < 2 || reducedMotionQuery.matches) {
        return;
      }
      timer = window.setInterval(function () {
        activate(current + 1, false);
      }, delay);
    }

    function stopForGood() {
      stopped = true;
      stopTimer();
    }

    function onTabClick(event) {
      var index = tabs.indexOf(event.currentTarget);
      if (index === -1) {
        return;
      }
      stopForGood();
      activate(index, false);
    }

    function onTabHover(event) {
      if (!hoverQuery.matches) {
        return;
      }
      onTabClick(event);
    }

    function onKeydown(event) {
      var index = tabs.indexOf(event.target);
      if (index === -1) {
        return;
      }

      var next = null;
      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          next = index + 1;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          next = index - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      stopForGood();
      activate(next, true);
    }

    function onPointerEnter() {
      hovering = true;
      stopTimer();
    }

    function onPointerLeave() {
      hovering = false;
      startTimer();
    }

    function onFocusIn() {
      focused = true;
      stopTimer();
    }

    function onFocusOut(event) {
      if (event.relatedTarget && root.contains(event.relatedTarget)) {
        return;
      }
      focused = false;
      startTimer();
    }

    function onBlockSelect(event) {
      var index = tabs.indexOf(event.target);
      if (index === -1) {
        return;
      }
      stopForGood();
      activate(index, false);
    }

    function onMotionChange() {
      startTimer();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', onTabClick);
      if (hoverTrigger) {
        tab.addEventListener('mouseenter', onTabHover);
      }
    });
    root.addEventListener('keydown', onKeydown);
    root.addEventListener('mouseenter', onPointerEnter);
    root.addEventListener('mouseleave', onPointerLeave);
    root.addEventListener('focusin', onFocusIn);
    root.addEventListener('focusout', onFocusOut);
    root.addEventListener('shopify:block:select', onBlockSelect);
    reducedMotionQuery.addEventListener('change', onMotionChange);

    activate(0, false);
    startTimer();

    root.nbNsV2NaDestroy = function () {
      stopTimer();
      tabs.forEach(function (tab) {
        tab.removeEventListener('click', onTabClick);
        tab.removeEventListener('mouseenter', onTabHover);
      });
      root.removeEventListener('keydown', onKeydown);
      root.removeEventListener('mouseenter', onPointerEnter);
      root.removeEventListener('mouseleave', onPointerLeave);
      root.removeEventListener('focusin', onFocusIn);
      root.removeEventListener('focusout', onFocusOut);
      root.removeEventListener('shopify:block:select', onBlockSelect);
      reducedMotionQuery.removeEventListener('change', onMotionChange);
      root.nbNsV2NaInit = false;
      root.nbNsV2NaDestroy = null;
    };
  }

  function initAll(scope) {
    var container = scope || document;
    var roots = Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR));

    if (container.nodeType === 1 && container.matches && container.matches(ROOT_SELECTOR)) {
      roots.push(container);
    }

    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = Array.prototype.slice.call(event.target.querySelectorAll(ROOT_SELECTOR));
    roots.forEach(function (root) {
      if (typeof root.nbNsV2NaDestroy === 'function') {
        root.nbNsV2NaDestroy();
      }
    });
  });
})();
